import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/deltapro/pc/');
const { EFPic: EFPic2 } = createEFPic('');
export default function Section3New() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('delta_pro_new');
    const { locale } = useRouter();
    // const LOCAL_SITES: string[] = ['us', 'ca'];
    const LOCAL_SITES: string[] = [''];

    const web1Map: any = {
        // us: ['DETALPRO_web1/1.webp', 'DETALPRO_web1/1.jpg'],
        us: ['DETALPRO_web1/DETAL PRO_web_1.webp', 'DETALPRO_web1/DETAL PRO_web_1.png'],
        ph: ['DETALPRO_web1/DETAL PRO_web_1.webp', 'DETALPRO_web1/DETAL PRO_web_1.png'],
        au: ['DETALPRO_web1/DETAL PRO_web_1_au.webp', 'DETALPRO_web1/DETAL PRO_web_1_au.png'],
        jp: ['DETALPRO_web1/DETAL PRO_web_1_jp.webp', 'DETALPRO_web1/DETAL PRO_web_1_jp.png'],
        uk: ['DETALPRO_web1/DETAL PRO_web_1_uk.webp', 'DETALPRO_web1/DETAL PRO_web_1_uk.png'],
        de: ['DETALPRO_web1/DETAL PRO_web_1_eu.webp', 'DETALPRO_web1/DETAL PRO_web_1_eu.png'],
        fr: ['DETALPRO_web1/DETAL PRO_web_1_eu.webp', 'DETALPRO_web1/DETAL PRO_web_1_eu.png'],
        it: ['DETALPRO_web1/DETAL PRO_web_1_eu.webp', 'DETALPRO_web1/DETAL PRO_web_1_eu.png'],
        es: ['DETALPRO_web1/DETAL PRO_web_1_eu.webp', 'DETALPRO_web1/DETAL PRO_web_1_eu.png'],
        ru: ['DETALPRO_web1/DETAL PRO_web_1_eu.webp', 'DETALPRO_web1/DETAL PRO_web_1_eu.png'],
        cis: ['DETALPRO_web1/DETAL PRO_web_1_eu.webp', 'DETALPRO_web1/DETAL PRO_web_1_eu.png'],
        cn: ['DETALPRO_web1/DETAL PRO_web_1_cn.webp', 'DETALPRO_web1/DETAL PRO_web_1_cn.png'],
        za: ['DETALPRO_web1/DETAL PRO_web_1_za.webp', 'DETALPRO_web1/DETAL PRO_web_1_za.png'],
        sa: ['DETALPRO_web1/DETAL PRO_web_1_uk.webp', 'DETALPRO_web1/DETAL PRO_web_1_uk.png'],
        ph: 'https://websiteoss.ecoflow.com/upload/image/1751092323944/bm.png',
    };

    return (
        <div
            className={`${css.section03} GtmModuleData-section`}
            data-section-id={css.section03}
            data-section-title={t('second_capacity_value') + t('second_capacity')}
        >
            <div className="top">
                <div className="tl">
                    <div className="tlt box">
                        <EFPic name={['DETAL PRO_web_2.webp', 'DETAL PRO_web_2.png']} alt={t('second_ac_onput')} aria-label={t('second_ac_onput')} />
                        <p className="tit">
                            {t('second_ac_onput_value')}
                            <br />
                            {t('second_ac_onput')}
                        </p>
                    </div>
                    <div className="tlb box">
                        <EFPic name={['Vehicle-Power.webp', 'Vehicle-Power.png']} alt={t('section3_Vehicle')} aria-label={t('section3_Vehicle')} />
                        <p className="tit">{t('section3_Vehicle')}</p>
                    </div>
                </div>
                <div className="tm box">
                    {locale === 'ph' ? (
                        <EFPic2 name={web1Map[locale] || web1Map['us']} alt={t('second_capacity_value')} aria-label={t('second_capacity_value')} />
                    ) : (
                        <EFPic name={web1Map[locale] || web1Map['us']} alt={t('second_capacity_value')} aria-label={t('second_capacity_value')} />
                    )}
                    {LOCAL_SITES.includes(locale) ? (
                        <p className="tit">{t('second_expandable_choice')}</p>
                    ) : (
                        <p className="tit">
                            {t('second_capacity_value')}
                            <br />
                            {t('second_capacity')}
                        </p>
                    )}
                </div>
                {!LOCAL_SITES.includes(locale) && (
                    <div className="tr box">
                        <EFPic
                            name={['DETAL PRO_web_6.webp', 'DETAL PRO_web_6.png']}
                            alt={t('second_expandable_ecosystem')}
                            aria-label={t('second_expandable_ecosystem')}
                        />
                        <p className="tit">{t('second_expandable_ecosystem')}</p>
                    </div>
                )}
                {LOCAL_SITES.includes(locale) && (
                    <div className="tr">
                        <div className="trt box">
                            <EFPic
                                name={['DETALPRO_web1/2.webp', 'DETALPRO_web1/2.jpg']}
                                alt={t('second_capacity_value')}
                                aria-label={t('second_capacity_value')}
                            />
                            <p className="tit">
                                {t('second_capacity_value')}
                                <br />
                                {t('second_capacity')}
                            </p>
                        </div>
                        <div className="trb box">
                            <EFPic
                                name={['DETALPRO_web1/3.webp', 'DETALPRO_web1/3.jpg']}
                                alt={t('second_expandable_ecosystem')}
                                aria-label={t('second_expandable_ecosystem')}
                            />
                            <p className="tit">{t('second_expandable_ecosystem')}</p>
                        </div>
                    </div>
                )}
            </div>
            <div className="bottom">
                <div className="bl box">
                    <EFPic name={['DETAL PRO_web_3.webp', 'DETAL PRO_web_3.png']} alt={t.raw('second_flow_charge')} aria-label={t.raw('second_flow_charge')} />
                    <p className="tit" dangerouslySetInnerHTML={{ __html: t.raw('second_flow_charge') }}></p>
                </div>
                <div className="bm box">
                    <EFPic name={['Whole-Home.webp', 'Whole-Home.png']} alt={t('section3_Whole_Home')} aria-label={t('section3_Whole_Home')} />
                    <p className="tit">
                        {t('section3_Whole_Home')}
                        <br />
                        {t('second_msection3_Whole_Homeulticharge')}
                    </p>
                </div>
                <div className="br">
                    <div className="brt box">
                        <p className="tit">{t('second_solar_input_no_html')}</p>
                    </div>
                    <div className="brb box">
                        <p className="tit">{t('second_lfp_battery_chemistry')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
